import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/pagesComponents/Achats.jsx");
